<div class="absolute inset-0 z-50">
  <div
    class="fixed backdrop-brightness-50 h-full w-full flex place-items-center place-content-center text-lg"
    (click)="closePopup()"
  >
    <div
      class="flex flex-col bg-white w-96 rounded-lg"
      (click)="$event.stopPropagation()"
    >
      <div
        class="bg-red-600 text-white text-3xl font-rockwell py-4 px-12 text-center rounded-t-lg"
      >
        {{ "auth.forgotPassword.title" | translate }}
      </div>
      <div class="p-4">
        <div class="text-center">
          {{ "auth.forgotPassword.dontWorry" | translate }}
        </div>
        <div class="text-center">
          {{ "auth.forgotPassword.sendNewPassword" | translate }}
        </div>
        <form [formGroup]="formGroup" (submit)="sendNewPassword()">
          <app-text-input
            [control]="formGroup.get('email')!"
            [placeholder]="'auth.forgotPassword.email' | translate"
          ></app-text-input>
          <div class="mt-6 w-4/5 mx-auto">
            <button
              class="text-white font-bold py-3 text-xl rounded w-full"
              [ngClass]="
                formGroup.valid ? 'bg-red-600 hover:bg-red-700' : 'bg-gray-400'
              "
              [disabled]="!formGroup.valid"
              type="submit"
            >
              {{ "auth.forgotPassword.sendButton" | translate }}
            </button>
          </div>
        </form>
        <div class="mt-8 flex flex-col items-center">
          <button (click)="redirectToLogin()" class="hover:text-red-500">
            {{ "auth.forgotPassword.return" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
